import React from "react";

import { ICONS } from "../constants";

const Loader = ({ src }) => {
  if (src) {
    return <img src={src} alt="loading" />;
  }

  return (
    <span className="datatable_actions-loading">
      <ICONS.Spinner />
    </span>
  );
};

export default Loader;
